export default "images/车灯开启情况-位置灯.png";